import { render, staticRenderFns } from "./TarjetaDatos.vue?vue&type=template&id=71c7a6de&scoped=true&"
import script from "./TarjetaDatos.vue?vue&type=script&lang=js&"
export * from "./TarjetaDatos.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaDatos.vue?vue&type=style&index=0&id=71c7a6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c7a6de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardSubtitle,VCol,VDivider,VIcon,VRow,VSheet})
